<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Upload shape File</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div style="height: 600px;">
        <!-- <iframe 
            src="https://webmaptest.environment.nsw.gov.au/MapViewer/QuickMap.aspx?mapfilename=BOP&PaymentNum="
            style="border: 0; width: 100%; height: 100%"> Your browser doesn't support iFrames.</iframe> -->

              <iframe [src]="safeUrl" width="100%" height="600" frameborder="0" style="border:0" allowfullscreen></iframe>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
</div>
